import { render, staticRenderFns } from "./CarRepairItemModal.vue?vue&type=template&id=bff6f322&scoped=true&"
import script from "./CarRepairItemModal.vue?vue&type=script&lang=js&"
export * from "./CarRepairItemModal.vue?vue&type=script&lang=js&"
import style0 from "./CarRepairItemModal.vue?vue&type=style&index=0&id=bff6f322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff6f322",
  null
  
)

export default component.exports